import { gql } from '@apollo/client';
import { CONTACT_FIELDS } from '../contact';
import { ADDRESS_FIELDS } from '../address';
import { PROFILE_FIELDS } from './profile.fields';

export const PROFILE_DETAIL_FIELDS = gql`
  ${CONTACT_FIELDS}
  ${ADDRESS_FIELDS}
  ${PROFILE_FIELDS}
  fragment ProfileDetailsFields on Profile {
    ...ProfileFields
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
  }
`;
